import Request from './request'

async function fetch (data) {
  return Request('get', 'api/stocks', data)
}

async function getLevelOneStock (data) {
  return Request('get', 'stocks/get-level-one-stock', data)
}

export default {
  fetch,
  getLevelOneStock
}